












































































import {Component, Vue} from 'vue-property-decorator';

import {projectStore, userStore} from '@/store/store';
// import {RecursiveFolder} from '@components/Projects/RecursiveFolder.vue';
import {IProjectMetadata, IR23Report, IR23ReportMetadata} from '@/interfaces/report';
import {dateDisplayBasic, dateTimeDisplay} from '@/lib/util/dateFunctions';
import {getProjectMetadataFromR23Report} from '@/modules/design/lib/r23ToSuiteTransformers';
import {convertReportContents} from '@/lib/legacyMigration';

@Component({
  name: 'ConvertReports',
  components: {},
  computed: {},
  methods: {},
})
export default class ConvertReports extends Vue {
  displayLegacyReports: boolean = false;

  formatDateTime = dateTimeDisplay;

  projects: IProjectMetadata[] = [];

  // Size of icons in actions menu
  iconSize = 'lg';

  get errors() {
    return projectStore.httpErrors;
  }

  clearErrors() {
    projectStore.clearErrors();
  }

  // projectNewFolderId: string | null = null;
  // projectToEdit: IR23ReportMetadata | null = null;
  // store = store;

  // get projectsInActiveFolder(): IProjectMetadata[] {
  //   return projectStore.availableProjects;
  // }

  dateDisplay(isoString: string): string {
    return dateDisplayBasic(isoString);
  }

  loadSuiteProjects() {
    projectStore.loadAvailableProjects().then((projects) => {
      console.log("projects", projects);
      this.projects = JSON.parse(JSON.stringify(projects))
    });
  }

  projectHasBeenConverted(r23ReportId: number) {
    return this.projects.filter(p => p.r23ReportId === r23ReportId).length > 0
  }

  convertedProject(r23ReportId: number): IProjectMetadata[] | undefined | null {
    return this.projects.filter(p => p.r23ReportId === r23ReportId)
  }

  setCurrentProject(id: number) {
    projectStore.setProjectId(id)
  }

  numReports = 0;

  numStarted = 0;

  numConverted = 0;

  migrateOne(r23ReportId: number) {
    this.clearErrors();
    const R = this.legacyReports.filter((r) => r.r23ReportId === r23ReportId)[0];
    this.convertProject(R, true);
    this.loadReports();
  }

  async convertProject(R: IR23ReportMetadata, force = false) {
    projectStore.loadLegacyReportContent(R.r23ReportId).then(async (report: IR23Report) => {
      if (report !== null) {

        // Convert Metadata
        if (userStore.user) {
          const newProjectMeta = getProjectMetadataFromR23Report(R, report, userStore.user);

          // Create the Suite project and construct scenarios
          return projectStore.createProject(newProjectMeta).then(
              (projectMeta) => {
                if (projectMeta !== null) {
                  convertReportContents(R, report, projectMeta, force);
                }
                this.update();
              }
          );
        }
      } else {
        projectStore.pushError({
          name: 'Conversion failure',
          message: `Loading project failed for ${R.r23ReportId} ${R.reportTitle}`,
          data: null,
          viewed: false,
        });
      }
      this.loadReports();
      this.loadSuiteProjects();
    });
  }

  performMigration() {
    this.clearErrors();
    this.numReports = this.legacyReports.length;
    this.numConverted = 0;

    console.log(`Beginning migration of ${this.numReports} projects`);

    this.legacyReports.forEach(async (R) => {
      R.conversion_started = true;
      this.numStarted += 1;
      await this.convertProject(R);
      this.numConverted += 1;
    });
    // Reload reports for display
    this.loadReports();
  }

  loadReports() {
    this.clearErrors();
    this.numReports = 0;
    this.numStarted = 0;
    this.numConverted = 0;
    projectStore.loadAvailableReportsLegacy();
    this.numReports = projectStore.availableReportsLegacy.length;
  }

  get legacyReportsAreAvailable() {
    // Load all folder info
    if (userStore.userIsLoggedIn) {
      return projectStore.checkForLegacyReports(userStore.user);
    }
    return false;
  }

  get legacyReports() {
    return projectStore.availableReportsLegacy;
  }

  get fields() {
    return [
      {
        key: 'convert',
      },
      {
        key: 'r23ReportId',
        label: 'Legacy ID',
      },
      {
        key: 'reportTitle',
        label: 'Project Name',
      },
      // {
      //   key: 'created',
      // },
      {
        key: 'converted',
      },
    ];
  }

  rowClass(item: any) {
    if (item.conversion_complete) {
      return 'table-success';
    }
    return null;
  }


  get legacyFields() {
    return [
      'convert',
      'r23ReportId',
      'reportTitle',
      'created',
      'updated',
      'conversion_started',
      'conversion_complete',
      'conversion_done_design',
      'conversion_done_lcca',
      'conversion_done_analyze',
      'conversion_done_other',
    ];
  }

  update() {

    this.loadReports();
    this.loadSuiteProjects();
  }

  mounted() {
    this.update()
  }
}
